import axios, { AxiosError } from "axios";
import { forceLogout } from "./authService";
const protectedAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});
    const baseUrl = 

protectedAPI.interceptors.request.use(
  (config) => {
    const tokenStr = localStorage.getItem("authToken");

    if (tokenStr) {
      const { access_token, token_type } = JSON.parse(tokenStr);

      if (access_token && token_type) {
        config.headers = config.headers || {};
        config.headers.Authorization = `${token_type} ${access_token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

protectedAPI.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error?.response?.status === 401) {
      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default protectedAPI;
